import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = "Arena Movement Physiotherapy";

export default function Seo({ title, description, path = "" }) {
  const fullTitle = title ? `${title} | ${BASE}` : `Physiotherapy Sandringham | ${BASE}`;
  const url = `https://www.arenamovementphysiotherapy.com.au${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <link rel="canonical" href={url} />
    </Helmet>
  );
}
